<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="table-wrap">
        <el-form label-width="100px">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item :label="$t('text.kssj')">
                <el-date-picker
                  v-model="starttime"
                  type="datetime"
                  :placeholder="$t('placeholder.xzrq')"
                  value-format="yyyy-MM-dd HH:00:00"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('text.jssj')">
                <el-date-picker
                  v-model="endtime"
                  type="datetime"
                  :placeholder="$t('placeholder.xzrq')"
                  value-format="yyyy-MM-dd HH:00:00"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-button
                type="primary"
                icon="el-icon-video-play"
                @click="handleQuery"
              >{{ $t('button.yl') }}</el-button>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportTable"
              >{{ $t('button.dc') }}</el-button>
              <el-button
                type="primary"
                @click="setprice"
              >{{ $t('button.djsz') }}</el-button>
              <el-button
                type="primary"
                icon="el-icon-video-play"
                @click="handleQuery"
              >{{ $t('button.csyl') }}</el-button>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportTable"
              >{{ $t('button.csdc') }}</el-button>
            </el-col>
            <el-col v-if="showtable">
              <table border="1">
                <caption>
                  {{ $store.getters.station.orgname }}项目电费结算单
                </caption>
                <caption>
                  结算时间:{{
                    this.$parseTime(starttime, "yyyy年MM月dd日")
                  }}/{{
                    this.$parseTime(endtime, "yyyy年MM月dd日")
                  }}
                </caption>
                <tbody>
                  <tr>
                    <td rowspan="7" style="width: 220px">月度光伏发电量(表一)</td>
                    <td rowspan="2" style="width: 250px">
                      <div class="line"><b>分时</b><em>项目</em></div>
                    </td>
                    <td colspan="3" style="width: 150px">并网柜计量表</td>
                    <td rowspan="2" style="width: 150px">总计</td>
                    <td colspan="2" rowspan="2">备注(电工签字确认)</td>
                  </tr>
                  <tr>
                    <td>峰时</td>
                    <td>平时</td>
                    <td>谷时</td>
                  </tr>
                  <tr>
                    <td>上月正向有功抄表示数</td>
                    <td>{{ solar.lastmonth.peak }}</td>
                    <td>{{ solar.lastmonth.flat }}</td>
                    <td>{{ solar.lastmonth.valley }}</td>
                    <td>{{ solar.lastmonth.total }}</td>
                    <td rowspan="6" />
                  </tr>
                  <tr>
                    <td>本月正向有功抄表示数</td>
                    <td>{{ solar.thismonth.peak }}</td>
                    <td>{{ solar.thismonth.flat }}</td>
                    <td>{{ solar.thismonth.valley }}</td>
                    <td>{{ solar.thismonth.total }}</td>
                  </tr>
                  <tr>
                    <td>本月与上月正向有功示数差</td>
                    <td>{{ solar.delta.peak }}</td>
                    <td>{{ solar.delta.flat }}</td>
                    <td>{{ solar.delta.valley }}</td>
                    <td>{{ solar.delta.total }}</td>
                  </tr>
                  <tr>
                    <td>电表倍率</td>
                    <td colspan="3">{{ solar.rate }}</td>
                    <td>/</td>
                  </tr>
                  <tr>
                    <td>本月正向电量(度)</td>
                    <td>{{ solar.actual.peak }}</td>
                    <td>{{ solar.actual.flat }}</td>
                    <td>{{ solar.actual.valley }}</td>
                    <td>{{ solar.actual.total }}</td>
                  </tr>
                </tbody>
                <tbody v-if="flag">
                  <tr>
                    <td rowspan="7" style="width: 220px">月度光伏发电量(表二)</td>
                    <td rowspan="2" style="width: 250px">
                      <div class="line"><b>分时</b><em>项目</em></div>
                    </td>
                    <td colspan="3" style="width: 150px">并网柜计量表</td>
                    <td rowspan="2" style="width: 150px">总计</td>
                    <td rowspan="7" colspan="2" />
                  </tr>
                  <tr>
                    <td>峰时</td>
                    <td>平时</td>
                    <td>谷时</td>
                  </tr>
                  <tr>
                    <td>上月正向有功抄表示数</td>
                    <td>{{ solar2.lastmonth.peak }}</td>
                    <td>{{ solar2.lastmonth.flat }}</td>
                    <td>{{ solar2.lastmonth.valley }}</td>
                    <td>{{ solar2.lastmonth.total }}</td>
                  </tr>
                  <tr>
                    <td>本月正向有功抄表示数</td>
                    <td>{{ solar2.thismonth.peak }}</td>
                    <td>{{ solar2.thismonth.flat }}</td>
                    <td>{{ solar2.thismonth.valley }}</td>
                    <td>{{ solar2.thismonth.total }}</td>
                  </tr>
                  <tr>
                    <td>本月与上月正向有功示数差</td>
                    <td>{{ solar2.delta.peak }}</td>
                    <td>{{ solar2.delta.flat }}</td>
                    <td>{{ solar2.delta.valley }}</td>
                    <td>{{ solar2.delta.total }}</td>
                  </tr>
                  <tr>
                    <td>电表倍率</td>
                    <td colspan="3">{{ solar2.rate }}</td>
                    <td>/</td>
                  </tr>
                  <tr>
                    <td>本月正向电量(度)</td>
                    <td>{{ solar2.actual.peak }}</td>
                    <td>{{ solar2.actual.flat }}</td>
                    <td>{{ solar2.actual.valley }}</td>
                    <td>{{ solar2.actual.total }}</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td rowspan="7" style="width: 220px">月度反向上网电量</td>
                    <td rowspan="2" style="width: 250px">
                      <div class="line"><b>分时</b><em>项目</em></div>
                    </td>
                    <td>峰时</td>
                    <td>平时</td>
                    <td>谷时</td>
                    <td rowspan="2" style="width: 150px">总计</td>
                    <td colspan="2" rowspan="2">备注(电工签字确认)</td>
                  </tr>
                  <tr />
                  <tr>
                    <td>上月反向有功抄表示数</td>
                    <td>{{ !useage?'':useage.lastmonth.peak }}</td>
                    <td>{{ !useage?'':useage.lastmonth.flat }}</td>
                    <td>{{ !useage?'':useage.lastmonth.valley }}</td>
                    <td>{{ !useage?'':useage.lastmonth.total }}</td>
                    <td rowspan="6" />
                  </tr>
                  <tr>
                    <td>本月反向有功抄表示数</td>
                    <td>{{ !useage?'':useage.thismonth.peak }}</td>
                    <td>{{ !useage?'':useage.thismonth.flat }}</td>
                    <td>{{ !useage?'':useage.thismonth.valley }}</td>
                    <td>{{ !useage?'':useage.thismonth.total }}</td>
                  </tr>
                  <tr>
                    <td>本月与上月反向有功示数差</td>
                    <td>{{ !useage?'':useage.delta.peak }}</td>
                    <td>{{ !useage?'':useage.delta.flat }}</td>
                    <td>{{ !useage?'':useage.delta.valley }}</td>
                    <td>{{ !useage?'':useage.delta.total }}</td>
                  </tr>
                  <tr>
                    <td>电表倍率</td>
                    <td colspan="3">{{ !useage?'':useage.rate }}</td>
                    <td>/</td>
                  </tr>
                  <tr>
                    <td>本月反向电量(度)</td>
                    <td>{{ !useage?'':useage.actual.peak }}</td>
                    <td>{{ !useage?'':useage.actual.flat }}</td>
                    <td>{{ !useage?'':useage.actual.valley }}</td>
                    <td>{{ !useage?'':useage.actual.total }}</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td rowspan="4">月度电费结算</td>
                    <td>
                      <div class="line2"><b>分时</b><em>项目</em></div>
                    </td>
                    <td style="width: 150px">
                      峰时电量(并网柜计量表正向峰时电量-反向峰时电量)
                    </td>
                    <td style="width: 150px">
                      平时电量(并网柜计量表正向平时电量-反向平时电量)
                    </td>
                    <td style="width: 150px">
                      谷时电量(并网柜计量表正向平时电量-反向平时电量)
                    </td>
                    <td>总计</td>
                    <td>备注</td>
                  </tr>
                  <tr>
                    <td>本月结算电量(度)</td>
                    <td>{{ payment.energy.peak }}</td>
                    <td>{{ payment.energy.flat }}</td>
                    <td>{{ payment.energy.valley }}</td>
                    <td>{{ payment.energy.total }}</td>
                    <td rowspan="3">
                      <div class="line3" />
                    </td>
                  </tr>
                  <tr>
                    <td>结算电价(元/度)</td>
                    <td>{{ payment.price.peak }}</td>
                    <td>{{ payment.price.flat }}</td>
                    <td>{{ payment.price.valley }}</td>
                    <td>{{ payment.price.total }}</td>
                  </tr>
                  <tr>
                    <td>本月电费结算金额(元)</td>
                    <td>{{ payment.payment.peak }}</td>
                    <td>{{ payment.payment.flat }}</td>
                    <td>{{ payment.payment.valley }}</td>
                    <td>{{ payment.payment.total }}</td>
                  </tr>
                </tbody>
              </table>
              <p>
                <span>{{
                  this.$parseTime(endtime, "yyyy年MM月dd日")
                }}</span><span>结算金额:{{ payment.payment.total.toFixed(2) }}</span>
              </p>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-dialog
        :title="$t(dialogAddTitle)"
        :visible.sync="showAddDialog"
        width="600px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          label-width="140px"
        >
          <el-form-item :label="$t('text.jdldj')">
            <el-input
              v-model="psharp"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.pdj')">
            <el-input
              v-model="pflat"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.fdj')">
            <el-input
              v-model="ppeak"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.gdj')">
            <el-input
              v-model="pvalley"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.pdldjyhxs')">
            <el-input
              v-model="rflat"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.fdldjyhxs')">
            <el-input
              v-model="rpeak"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.gdldjyhxs')">
            <el-input
              v-model="rvalley"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('text.jdldjyhxs')">
            <el-input
              v-model="rsharp"
              clearable
            />
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="handleAddSubmit"
          >{{ $t('button.qd') }}</el-button>
          <el-button @click="cancelset">{{ $t('button.qx') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { MeterRead1, ExpMeterRead1, SetEPrices, GetEPrices } from '@/api/Meter'

export default {
  name: 'Menu',
  components: {},
  data () {
    return {
      payment: {},
      solar: {},
      useage: {},
      starttime: '',
      endtime: '',
      fullLoading: null,
      showtable: false,
      solar2: {},
      flag: false,
      dialogAddTitle: 'button.djsz',
      showAddDialog: false,
      pflat: '',
      ppeak: '',
      psharp: '',
      pvalley: '',
      ptotal: '',
      rflat: '',
      rpeak: '',
      rsharp: '',
      rvalley: ''
    }
  },
  created () {},
  methods: {
    handleQuery () {
      MeterRead1({
        orgid: this.$store.getters.station.id,
        starttime: this.starttime,
        endtime: this.endtime,
        pricepeak: '1.0347',
        priceflat: '0.606',
        pricevalley: '0.2589',
      }).then((res) => {
        if (res.data) {
          this.payment = res.data.payment
          this.solar = res.data.solar[0]
          this.useage = res.data.useage[0] || []
          if (res.data.solar[1]) {
            this.solar2 = res.data.solar[1]
            this.flag = true
          }
          this.showtable = true
        }
      })
    },
    exportTable () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      ExpMeterRead1({
        orgid: this.$store.getters.station.id,
        starttime: this.starttime,
        endtime: this.endtime,
        pricepeak: '1.0347',
        priceflat: '0.6068',
        pricevalley: '0.2589',
      })
        .then((res) => {
          this.fullLoading.close()
          window.location.href = res.data
        })
        .catch(() => {
          this.fullLoading.close()
        })
    },
    setprice () {
      GetEPrices({ id: this.$store.getters.station.id }).then(res => {
        this.pflat = res.data.pflat
        this.ppeak = res.data.ppeak
        this.psharp = res.data.psharp
        this.pvalley = res.data.pvalley
        this.ptotal = res.data.ptotal
        this.rflat = res.data.rflat
        this.rpeak = res.data.rpeak
        this.rsharp = res.data.rsharp
        this.rvalley = res.data.rvalley
      })
      this.showAddDialog = true
    },
    handleAddSubmit () {
      SetEPrices({
        pflat: this.pflat,
        ppeak: this.ppeak,
        psharp: this.psharp,
        pvalley: this.pvalley,
        ptotal: this.ptotal,
        rflat: this.rflat,
        rpeak: this.rpeak,
        rsharp: this.rsharp,
        rvalley: this.rvalley,
        id: this.$store.getters.station.id
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('notice.sjszcg'),
          duration: 1 * 1000
        })
        this.showAddDialog = false
      })
    },
    cancelset () {
      this.$message({
        type: 'success',
        message: this.$t('notice.qxsz'),
        duration: 1 * 1000
      })
      this.showAddDialog = false
    }
  },
}
</script>
<style lang="stylus" scoped>
.app-container {
  padding: 10px;
  background-color: #1c2550;
}

.table-wrap
  background-color: #1D3666
  border: none
>>>.el-form-item__label
    color #1CC197
>>>.el-input__inner
    background-color #1D3666
    border 1px solid #175E77
    color #fff
table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
  color #fff
}

p {
  text-align: center;
}

caption {
  text-align: center;
}

b, em {
  font-style: normal;
  font-weight: normal;
  display: block;
  padding-left: 150px;
}

em {
  padding-left: 0;
}

.line {
  background: linear-gradient(9.5deg, transparent 49.5%, #000 49.5%, #fff 50.5%, transparent 50.5%);
}

.line2 {
  height: 85px;
  background: linear-gradient(19deg, transparent 49.5%, #000 49.5%, #fff 50.5%, transparent 50.5%);
}
.line3 {
  height: 85px;
  background: linear-gradient(8deg, transparent 49.5%, #000 49.5%, #fff 50.5%, transparent 50.5%);
}

.line2 b, .line2 em {
  font-style: normal;
  font-weight: normal;
  display: block;
  padding-left: 150px;
  padding-top: 20px;
}

.line2 em {
  padding-left: 10px;
  padding-top: 20px;
}
</style>

